// @flow

import { getEndpoint } from './crud-factory'

export async function getFormsAppEnvironments(): Promise<
  FormsAppEnvironment[]
> {
  const { formsAppEnvironments } = await getEndpoint('/forms-app-environments')
  return formsAppEnvironments
}
